import { Component, ElementRef } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { MixpanelService } from '../../../services/mixpanel.service';

@Component({
    selector: 'app-easter-egg-modal',
    templateUrl: './easter-egg-modal.component.html',
    styleUrls: ['./easter-egg-modal.component.css']
})
export class EasterEggModalComponent {
    currentView: 'prompt' | 'reveal' = 'prompt';
    videoUrl = 'assets/images/modals/overthinking.mp4';

    constructor(
        public ref: DynamicDialogRef,
        private mixpanel: MixpanelService,
        private elementRef: ElementRef
    ) {}

    onReveal(): void {
        this.mixpanel.track('Easter Egg Button Clicked');
        this.currentView = 'reveal';

        setTimeout(() => {
            const modalContainer = this.elementRef.nativeElement.closest('.p-dialog');
            const modalContent = this.elementRef.nativeElement.closest('.p-dialog-content');
            const modalHeader = modalContainer?.querySelector('.p-dialog-header');

            if (modalContainer) {
                modalContainer.classList.remove('dashboard-modal');
                modalContainer.classList.add('gif-modal-dialog');

                modalContainer.style.width = '400px';
            }

            if (modalHeader) {
                (modalHeader as HTMLElement).style.display = 'none';
            }

            if (modalContent) {
                modalContent.style.backgroundColor = 'transparent';
                modalContent.style.border = 'none';
                modalContent.style.boxShadow = 'none';
                modalContent.style.borderRadius = '12px';
                modalContent.style.padding = '0';
            }
        }, 0);
    }

    onClose(): void {
        this.ref.close();
    }
}
